import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

import { AuthControllerService } from '../../store/auth-controller.service'

/**
 * Role guard that replicates the QuixAuthStoreGuard contract.
 * Route data can specify:
 *  - allowedRoles: string[]  — roles that may access the route
 *  - condition: 'OR' | 'AND' — defaults to 'OR' (at least one role required)
 */
export const roleGuard: CanActivateFn = (route) => {
  const authController = inject(AuthControllerService)
  const router = inject(Router)

  if (!authController.isLogged()) {
    router.navigate(['/home'])
    return false
  }

  const allowedRoles: string[] = route.data?.['allowedRoles'] ?? []
  if (allowedRoles.length === 0) {
    return true
  }

  const condition: 'OR' | 'AND' = route.data?.['condition'] ?? 'OR'
  const hasAccess =
    condition === 'AND'
      ? allowedRoles.every((role) => authController.hasRole(role))
      : allowedRoles.some((role) => authController.hasRole(role))

  if (!hasAccess) {
    router.navigate(['/home'])
  }

  return hasAccess
}
